import { createBlock } from 'factories/block';
import { Block } from '@chameleoncreator/creator-app';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';

export type ImageInteractionProps = InteractionProps & {};

// const contentForColumn = props => (i: number) => {
//   // return [() => createBlock('Text'), () => createBlock('Image')][i];
//   return [() => createBlock('Text'), () => createMediaBlock(props)][i];
// };

const createAssessmentIntroduction = (props?: {}) => {
  return createBlock('AssessmentIntroduction', [], { props: {} });
};

const createAssessmentQuestion = (props?: {}) => {
  return createBlock('AssessmentQuestion', [], { props: {} });
};

const createAssessmentResults = (props?: {}) => {
  return createBlock('AssessmentResults', [], { props: {} });
};

export const createAssessmentInteractionBlock = props => {
  return createBlock(
    'Interaction',
    [
      createBlock('Assessment', [
        createAssessmentIntroduction(),
        createAssessmentQuestion(),
        createAssessmentResults(),
      ]),

      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            // createBlock('ContinueButton', 'Continue' as any, {
            //   meta: { subType: 'continue' },
            // }),
            createContinueBtn(props.style),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        type: 'Assessment',
        name: props.name,
        sId: getSId('interaction'),
        style: props.style || {},
      },
      meta: {
        subType: 'Assessment',
        // layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
        //   props.columnsReversed ? 'Reversed' : ''
        // }`,
      },
    }
  );
};

// export const createFullPageTextBlock = (props: any) => {
//   // will fix this up later with the ' prop 'er definitions etc

//   const { lockDown = 0, style } = props as any;

//   return createBlock(
//     'Interaction',
//     [
//       createBlock('FullPageText', [
//         createBlock('Text', [], { props: { useBackgroundControls: true } }),
//       ]),

//       createBlock('SingleColumnLayout', [
//         createBlock(
//           'Column',
//           [
//             // createBlock('ContinueButton', 'Continue' as any, {
//             //   meta: { subType: 'continue' },
//             // }),
//             createContinueBtn(style),
//           ],
//           {
//             props: {
//               flexDirection: 'row',
//               alignItems: 'center',
//               justifyContent: 'center',
//               flexWrap: 'wrap',
//             },
//             meta: {
//               subType: 'ButtonBlock',
//             },
//           }
//         ),
//       ]),
//     ],
//     {
//       props: {
//         type: 'FullPageText',
//         name: props.name,
//         sId: getSId('interaction'),
//         style: props.style || {},
//         lockDown,
//       },
//       meta: {
//         subType: 'FullPageText',
//         // layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
//         //   props.columnsReversed ? 'Reversed' : ''
//         // }`,
//       },
//     }
//   );
// };

export const interactionConfig = {};
